var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolomonIslands(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3141 27.3367C33.3148 21.336 33.5518 11.7557 28.0275 5.47081L16 16.0225L5.44824 28.05C11.7332 33.5743 21.3134 33.3374 27.3141 27.3367V27.3367Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68632 4.7083C10.687 -1.29238 20.2673 -1.52932 26.5522 3.99499L16.0004 16.0226L3.97308 26.5742C-1.55129 20.2893 -1.31429 10.709 4.68632 4.7083V4.7083Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.552 3.9949L3.9729 26.5741C4.20115 26.8338 4.43815 27.0885 4.68621 27.3365C4.93421 27.5845 5.18902 27.8215 5.44877 28.0499L28.0278 5.47065C27.7995 5.2109 27.5625 4.95615 27.3144 4.70809C27.0665 4.46022 26.8117 4.22315 26.552 3.9949V3.9949Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74126 5.58708L7.0867 6.65001H8.20426L7.30013 7.30682L7.64545 8.36976L6.74126 7.71282L5.83707 8.36976L6.18251 7.30682L5.27832 6.65001H6.39595L6.74126 5.58708Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.45 5.58708L12.7954 6.65001H13.9129L13.0088 7.30682L13.3542 8.36976L12.45 7.71282L11.5458 8.36976L11.8912 7.30682L10.9871 6.65001H12.1046L12.45 5.58708Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74126 11.1526L7.0867 12.2156H8.20426L7.30013 12.8724L7.64545 13.9354L6.74126 13.2784L5.83707 13.9354L6.18251 12.8724L5.27832 12.2156H6.39595L6.74126 11.1526Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.45 11.1526L12.7954 12.2156H13.9129L13.0088 12.8724L13.3542 13.9354L12.45 13.2784L11.5458 13.9354L11.8912 12.8724L10.9871 12.2156H12.1046L12.45 11.1526Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59557 8.36981L9.941 9.43275H11.0585L10.1544 10.0896L10.4998 11.1526L9.59557 10.4956L8.69138 11.1526L9.03675 10.0896L8.13257 9.43275H9.25019L9.59557 8.36981Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolomonIslands);
export default __webpack_public_path__ + "static/media/solomon-islands.45fac664.svg";
export { ForwardRef as ReactComponent };